var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscordAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord-avatar",
    transform: "translate(-1728 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(1728 31)",
    fill: "#fff",
    stroke: "#0068f7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Discord_Logo_sans_texte",
    d: "M18.624,10.8a18.142,18.142,0,0,0-4.478-1.389.068.068,0,0,0-.072.034,12.638,12.638,0,0,0-.558,1.145,16.749,16.749,0,0,0-5.03,0,11.591,11.591,0,0,0-.566-1.145.071.071,0,0,0-.072-.034A18.092,18.092,0,0,0,3.371,10.8a.064.064,0,0,0-.029.025A18.567,18.567,0,0,0,.091,23.349.076.076,0,0,0,.12,23.4a18.244,18.244,0,0,0,5.493,2.777.071.071,0,0,0,.077-.025,13.039,13.039,0,0,0,1.124-1.828.07.07,0,0,0-.038-.1,12.014,12.014,0,0,1-1.716-.818.071.071,0,0,1-.007-.117c.115-.086.231-.176.341-.267a.068.068,0,0,1,.071-.01,13.01,13.01,0,0,0,11.056,0,.068.068,0,0,1,.072.009c.11.091.225.182.342.268a.071.071,0,0,1-.006.117,11.274,11.274,0,0,1-1.717.817.07.07,0,0,0-.037.1A14.64,14.64,0,0,0,16.3,26.151a.07.07,0,0,0,.077.026,18.183,18.183,0,0,0,5.5-2.777.071.071,0,0,0,.029-.051,18.446,18.446,0,0,0-3.253-12.522A.056.056,0,0,0,18.624,10.8ZM7.352,20.85a2.114,2.114,0,0,1-1.977-2.217,2.1,2.1,0,0,1,1.977-2.217,2.091,2.091,0,0,1,1.977,2.217A2.1,2.1,0,0,1,7.352,20.85Zm7.31,0a2.114,2.114,0,0,1-1.977-2.217,2.1,2.1,0,0,1,1.977-2.217,2.091,2.091,0,0,1,1.977,2.217A2.1,2.1,0,0,1,14.662,20.85Z",
    transform: "translate(1737 33.204)",
    fill: "#0068f7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordAvatar);
export default __webpack_public_path__ + "static/media/discord-avatar.236f21ed1c69d218d79c7ec0709c2456.svg";
export { ForwardRef as ReactComponent };